<template>
  <div :class="$style.base">
    <InputElement
      v-model="value"
      v-bind="{ type: inputType, uid, hasError, focus, size, disabled, placeholder }"
    />
    <VisibilityToggle
      v-model="passwordVisible"
      :hasError="hasError"
      v-test="'_base-input-password-toggle'"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import InputElement from './_shared/InputElement.vue';
import props from './_shared/props';
import VisibilityToggle from './_shared/VisibilityToggle.vue';

export default defineComponent({
  components: {
    InputElement,
    VisibilityToggle,
  },
  inheritAttrs: false,
  props: {
    modelValue: String,
    type: String,
    ...props(),
  },
  emits: ['update:modelValue'],
  data() {
    return {
      passwordVisible: false,
    };
  },
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
    inputType() {
      return this.passwordVisible ? 'text' : 'password';
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  position: relative;
}
</style>
